{
  "header": {
    "title": "Question schedule",
    "description": "Review and analyze previous feedback responses"
  },
  "categorySection": {
    "title": "Category distribution",
    "questionCountWarning": "Low number of questions will impact data quality"
  },
  "month": {
    "current": "This month",
    "next": "Next month"
  },
  "questionHistoryTable": {
    "date": "Date",
    "question": "Question",
    "category": "Category",
    "status": "Status",
    "lastAsked": "Last Asked"
  }
}
